import { compose as a } from "../../tailwind-buddy-interface.js";
import { chipCommonStyles as e } from "../Chip/Chip.variants.js";
const i = a({
  slots: e.foundation,
  variants: {
    /** Sets the chip color. */
    appearance: {
      default: {},
      primary: {},
      destructive: {}
    },
    /** Sets the chip size. */
    size: {
      sm: e.sizeSm,
      md: e.sizeMd,
      lg: e.sizeLg
    },
    /** Sets the chip variant. */
    variant: {
      solid: e.variantSolid,
      subtle: e.variantSubtle,
      outlined: e.variantOutlined
    }
  },
  compoundVariants: [
    // isDisabled="true"
    {
      conditions: {
        isDisabled: !0
      },
      class: {
        /** TODO: use `-outline-offset-sm` once outline offset tokens are available */
        root: `
          bg-color-scheme-interactive-disabled-100
          outline-color-scheme-interactive-disabled-200
          outline
          outline-width-sm
          -outline-offset-1
          cursor-not-allowed
        `,
        label: "text-color-scheme-interactive-disabled-400",
        icon: "text-color-scheme-interactive-disabled-400"
      }
    },
    // variant="solid"
    {
      conditions: {
        variant: "solid",
        isDisabled: !1
      },
      class: {
        root: `
          shadow-sm
          hover:-translate-y-006
          active:translate-y-006
        `
      }
    },
    // variant="solid" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "solid",
        isDisabled: !1
      },
      class: {
        root: `
          bg-color-glass-secondary-inverse
          hover:bg-color-glass-tertiary-inverse
          active:bg-color-glass-primary-inverse
        `
      }
    },
    // variant="solid" / appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "solid",
        isDisabled: !1
      },
      class: {
        root: `
          bg-color-scheme-interactive-cta-500
          hover:bg-color-scheme-interactive-cta-400
          active:bg-color-scheme-interactive-cta-600
        `
      }
    },
    // variant="solid" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "solid",
        isDisabled: !1
      },
      class: {
        root: `
          bg-color-scheme-functional-negative-500
          hover:bg-color-scheme-functional-negative-400
          active:bg-color-scheme-functional-negative-600
        `
      }
    },
    // variant="subtle" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "subtle",
        isDisabled: !1
      },
      class: {
        root: `
          bg-color-scheme-neutral-100
          hover:bg-color-scheme-neutral-200
          active:bg-color-scheme-neutral-400
        `,
        label: "text-color-primary",
        icon: "text-icon-color-primary"
      }
    },
    // variant="subtle" / appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "subtle",
        isDisabled: !1
      },
      class: {
        root: `
          bg-color-scheme-interactive-cta-100
          hover:bg-color-scheme-interactive-cta-200
          active:bg-color-scheme-interactive-cta-400
        `,
        label: "text-color-scheme-interactive-cta-800",
        icon: "text-color-scheme-interactive-cta-500"
      }
    },
    // variant="subtle" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "subtle",
        isDisabled: !1
      },
      class: {
        root: `
          bg-color-scheme-functional-negative-100
          hover:bg-color-scheme-functional-negative-200
          active:bg-color-scheme-functional-negative-400
        `,
        label: "text-color-scheme-functional-negative-800",
        icon: "text-color-scheme-functional-negative-500"
      }
    },
    // variant="outlined" / appearance="default"
    {
      conditions: {
        appearance: "default",
        variant: "outlined",
        isDisabled: !1
      },
      class: {
        root: `
          outline-color-scheme-neutral-400
          hover:bg-color-scheme-neutral-100
          active:bg-color-scheme-neutral-200
        `,
        label: "text-color-primary",
        icon: "text-icon-color-primary"
      }
    },
    // variant="outlined" / appearance="primary"
    {
      conditions: {
        appearance: "primary",
        variant: "outlined",
        isDisabled: !1
      },
      class: {
        root: `
          outline-color-scheme-interactive-cta-400
          hover:bg-color-scheme-interactive-cta-100
          active:bg-color-scheme-interactive-cta-200
        `,
        label: "text-color-scheme-interactive-cta-800",
        icon: "text-color-scheme-interactive-cta-400"
      }
    },
    // variant="outlined" / appearance="destructive"
    {
      conditions: {
        appearance: "destructive",
        variant: "outlined",
        isDisabled: !1
      },
      class: {
        root: `
          outline-color-scheme-functional-negative-400
          hover:bg-color-scheme-functional-negative-100
          active:bg-color-scheme-functional-negative-200
        `,
        label: "text-color-scheme-functional-negative-800",
        icon: "text-color-scheme-functional-negative-400"
      }
    },
    // variant="solid" / appearance="default" / enableGroupHover
    {
      conditions: {
        appearance: "default",
        variant: "solid",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-glass-tertiary-inverse"
      }
    },
    // variant="subtle" / appearance="default" / enableGroupHover
    {
      conditions: {
        appearance: "default",
        variant: "subtle",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-neutral-200"
      }
    },
    // variant="outlined" / appearance="default" / enableGroupHover
    {
      conditions: {
        appearance: "default",
        variant: "outlined",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-neutral-100"
      }
    },
    // variant="solid" / appearance="primary" / enableGroupHover
    {
      conditions: {
        appearance: "primary",
        variant: "solid",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-interactive-cta-400"
      }
    },
    // variant="subtle" / appearance="primary" / enableGroupHover
    {
      conditions: {
        appearance: "primary",
        variant: "subtle",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-interactive-cta-200"
      }
    },
    // variant="outlined" / appearance="primary" / enableGroupHover
    {
      conditions: {
        appearance: "primary",
        variant: "outlined",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-interactive-cta-100"
      }
    },
    // variant="solid" / appearance="destructive" / enableGroupHover
    {
      conditions: {
        appearance: "destructive",
        variant: "solid",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-functional-negative-400"
      }
    },
    // variant="subtle" / appearance="destructive" / enableGroupHover
    {
      conditions: {
        appearance: "destructive",
        variant: "subtle",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-functional-negative-200"
      }
    },
    // variant="outlined" / appearance="destructive" / enableGroupHover
    {
      conditions: {
        appearance: "destructive",
        variant: "outlined",
        enableGroupHover: !0,
        isDisabled: !1
      },
      class: {
        root: "group-hover/chip:[&:not(:active)]:bg-color-scheme-functional-negative-100"
      }
    }
  ],
  defaultVariants: {
    appearance: "default",
    size: "md",
    variant: "solid"
  },
  responsiveVariants: ["size"]
})();
export {
  i as chipInteractiveVariants
};
